<template>
  <div>
    <h3 class="text-lg font-semibold mb-4">{{ $t('kpi_activity_title') }}</h3>
    <project-admin-quick-buttons v-if="!activityId" hiddenOption="nadieporahora-kpis-esta-fuera-de-esto" />
    <b-tabs type="is-boxed">
      <b-tab-item :label="$t('kpis_weekly')">
        <Kpis
          :projectId="projectId"
          :activity-id="activityId"
          @ActivityHomeShowFullWidth="emitKpiFlow"
        />
      </b-tab-item>
      <b-tab-item :label="$t('kpis_daily')">
        <KpisDaily
          :projectId="projectId"
          :activityId="activityId"
          @ActivityHomeShowFullWidth="emitKpiFlow"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Kpis from '../pages/admin/kpis/kpis.vue'
import ProjectAdminQuickButtons from '../components/project-admin-quick-buttons'
import KpisDaily from '../pages/admin/kpis/kpis-daily/kpis-daily.vue'

export default {
  name: "ActivityKpis",
  components: {
    Kpis,
    ProjectAdminQuickButtons,
    KpisDaily
  },
  props: {
    activityId: { type: Number, required: true },
    projectId: { type: Number, default: null }
  },
  methods: {
    emitKpiFlow(payload) {
      this.$emit('ActivityHomeShowFullWidth', payload)
    }
  }
}
</script>